<template>
  <v-card
    class="px-3 py-2 align-self-end rounded-lg rounded-be-0"
    color="primary"
    flat
    max-width="85%"
    tag="article"
    variant="tonal"
  >
    <div class="text-high-emphasis text-pre-wrap text-break">
      {{ message.content }}
    </div>
  </v-card>
</template>

<script lang="ts" setup>
import type { DeepAChatClientMessage } from '@/pocs/chat/types'

defineProps({
  message: {
    type: Object as PropType<DeepAChatClientMessage>,
    required: true,
  },
})
</script>
